import { BaseQueryFn, EndpointBuilder, FetchBaseQueryError } from '@reduxjs/toolkit/query';
import { APP_ENDPOINTS } from 'app/endpoints';
import { PaginatedResponse } from 'types/dtos';
import { ResponseNestedProductDto } from '../types/dtos';
import { buildQueryParams } from 'utils/api-helpers';

export type NestedProductsQueryParams = {
    page?: number;
    size?: number;
    website_id?: string;
    ids?: string[];
};

export default (builder: EndpointBuilder<BaseQueryFn, string, string>) =>
    builder.query<PaginatedResponse<ResponseNestedProductDto>, NestedProductsQueryParams>({
        async queryFn(_args, _queryApi, _extraOptions, fetchWithBQ) {
            const queryParams = buildQueryParams(_args);

            const nestedProductResult = await fetchWithBQ(`${APP_ENDPOINTS.NESTED_PRODUCTS}?${queryParams}`);

            if (nestedProductResult.error) return { error: nestedProductResult.error as FetchBaseQueryError };

            const nestedProduct = nestedProductResult.data as PaginatedResponse<ResponseNestedProductDto>;

            return {
                data: nestedProduct,
            };
        },
        providesTags: [{ type: 'nested-products', id: 'GET' }],
    });
